/**
 * Data service for loading and processing client data
 */

import { loadFromAPI } from './data-loading/apiDataLoader';
import { loadClientDataFallback } from './data-loading/fallbackDataLoader';
import { savePortfolioData } from './api/portfolioApi';
import { mergeWithCoordinates } from './api/geolocationApi';
import { processCountryData } from './data-processing/countryProcessor';
import { filterClientData, filterCountryData } from './data-processing/dataFilter';

/**
 * Load client data from backend API
 * @returns {Promise<Array>} The loaded client data
 */
export const loadClientData = loadFromAPI;

/**
 * Get client details in a standardized format
 * @param {Object} client - The client data
 * @returns {Object} The client details
 */
export const getClientDetails = (client) => {
  return {
    // Financial information
    revenue: client['Total Revenue'] || '$0.00',
    lastBookingRevenue: client['Last Booking Revenue'] || 'N/A',
    lastBooked: client['Last Booked'] || 'N/A',
    
    // Contact information
    contactName: client['Key Contact Name'] || 'Contact Representative',
    contactEmail: client['Key Contact Email'] || 'contact@client.com',
    previousManager: client['Previously Assigned Manager'] || 'None',
    
    // New fields from portfolio data
    timeZone: client['Time zone'] || 'N/A',
    tier: client['Tier'] || 'N/A',
    segment: client['Segment'] || 'N/A',
    rn: client['RN'] || 'N/A'
  };
};

// Re-export processing functions
export { processCountryData } from './data-processing/countryProcessor';
export { filterClientData, filterCountryData } from './data-processing/dataFilter';

// Re-export API functions to maintain existing interface
export { savePortfolioData } from './api/portfolioApi';
export { mergeWithCoordinates } from './api/geolocationApi';
